import ChartsService from '@/services/benchmarks/ChartsService.js';
import { getBenchmarkId, SERIES_BY_MEDIA, chartLegendOrder } from '@/utils';

import { chartsMutationTypes } from '../mutation-types';

export async function fetchSentimentsInTheComments({ commit, rootState, rootGetters }) {
  try {
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_LOADING, true);
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_ERROR, false);

    const groupIdListJoined = rootGetters['ui/getterGroupIdList'].join(',');
    const channelSelected = rootState.ui.channel;

    const paramsChartsService = {
      'benchmark-id': getBenchmarkId(),
      'group-id': groupIdListJoined,
      'start-date': rootState.ui.dateRange.start,
      'end-date': rootState.ui.dateRange.end,
      channel: channelSelected,
    };

    const { series } = await ChartsService.getSentimentsInTheComments(paramsChartsService);
    const categories = series.map((serie) => (serie.name));

    const sentimentsTypes = {
      positivo: 'positive',
      negativo: 'negative',
      neutro: 'neutral',
      'não classificado': 'notClassified',
    };

    if (!Array.isArray(series)) throw new Error();

    const formattedData = (data, percent, name) => {
      const sentiments = sentimentsTypes[name];
      const dataValue = Object.values(data).map(value => value[sentiments]);
      const percentValue = Object.values(percent).map(value => value[sentiments]);

      return dataValue.map((item, index) => ({ y: item, percent: percentValue[index] }));
    };

    function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const seriesData = Object.keys(chartLegendOrder.sentimentsInTheComments).map((key) => {
      const polarities = series.map((serie) => serie.polarities[0]);
      const percents = series.map((serie) => serie.percents[0]);
      return {
        name: capitalize(key),
        index: chartLegendOrder.sentimentsInTheComments[key.toLowerCase()],
        color: channelSelected === 'Todas'
          ? SERIES_BY_MEDIA.all[key.toLowerCase()]?.color
          : SERIES_BY_MEDIA[channelSelected.toLowerCase()][key.toLowerCase()]?.color,
        data: formattedData(polarities, percents, key),
      };
    });

    const colors = {
      series: seriesData,
      categories,
    };

    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_DATA, colors);
  } catch (e) {
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_ERROR, true);
    console.error(e);
    return e;
  } finally {
    commit(chartsMutationTypes.SENTIMENTS_IN_THE_COMMENTS_LOADING, false);
  }
}
